import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import '../BBAdmin/Css/Tooltip.css';
import { faHomeAlt, faGear, faUserCircle, faPlus, faSearch, faUserGroup, faX, faSignOut, faBuilding, faBars } from '@fortawesome/free-solid-svg-icons';
import { FaChevronDown, FaRegBell } from 'react-icons/fa';
import { requestPermission, handleForegroundNotifications } from '../push-notifications';
import { messaging,messagingPromise, getToken, onMessage } from '../firebase-config';
import { clearUserFromServiceWorker } from '../utils/serviceWorkerUtils';

const MHeader = ({ toggleSidebar }) => {
  const navigate = useNavigate();
  const [searchDropDown, setSearchDropDown] = useState(false);
  const [userDropDown, setUserDropDown] = useState(false);
  const [orgPopUp, setOrgPopUp] = useState(false);
  const [type, setType] = useState('');
  const [userData, setUserData] = useState(null);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const [notifications, setNotifications] = useState([]);  // To store notifications
  console.log("notifications:",notifications)
  const [notificationCount, setNotificationCount] = useState(0);  // To track unread notifications
  const [isNotificationPopupOpen, setIsNotificationPopupOpen] = useState(false);  // For controlling popup visibility
  
  const ref = useRef(null);
  
  const List = ['Items', 'Customers', 'Vendors', 'Quotes'];


useEffect(() => {
  //requestPermission(); // Ask for permission on mount
  //handleForegroundNotifications(); // Setup foreground handler
}, []);



/* const handleForegroundNotifications = () => {
  console.log("entered handleForegroundNotifications function")
  onMessage(messaging, (payload) => {
    console.log("Message received: ", payload);
    setNotifications((prev) => [
      ...prev,
      {
        title: payload?.notification?.title,
        body: payload?.notification?.body,
        time: new Date().toLocaleString()
      },
    ]);
    setNotificationCount(prevCount => prevCount + 1);
  });
}; */

/* const handleForegroundNotifications = () => {
        messagingPromise.then((messaging) => {
            if (messaging) {
                onMessage(messaging, (payload) => {
                    console.log('🔔 Foreground notification:', payload);
                    // Show custom toast or alert here
                    setNotifications((prev) => [
      ...prev,
      {
        title: payload?.notification?.title,
        body: payload?.notification?.body,
        time: new Date().toLocaleString()
      },
    ]);
    setNotificationCount(prevCount => prevCount + 1);
                });
            }
        });
}; */



  useEffect(() => {
    const storedUserData = sessionStorage.getItem('userData');
    if (storedUserData) {
      setUserData(JSON.parse(storedUserData));
    }
  }, []);

  // Fetch notifications from API
/*   const fetchNotifications = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_FORE_APILINK}/notifications`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'x-token': sessionStorage.getItem('token')
        }
      });
  
      const data = await response.json();
  
      if (response.ok) {
        setNotifications(data.notifications); // Assuming the API returns an array of notifications
        setNotificationCount(data.unreadCount); // Assuming the API returns unread notification count
      } else {
        console.error('Failed to fetch notifications');
      }
    } catch (error) {
      console.error('Error fetching notifications:', error);
    }
  };

  useEffect(() => {
    fetchNotifications(); // Fetch notifications when the component mounts
    const interval = setInterval(fetchNotifications, 60000); // Refresh notifications every 60 seconds
    return () => clearInterval(interval); // Clear interval on component unmount
  }, []); */

  const handleDropDownToggle = () => {
    setSearchDropDown(!searchDropDown);
  };

  const handleClickItem = (item) => {
    setType(item);
    setSearchDropDown(false);
  };

  const handleChangeSearch = () => {
    setSearchDropDown(false);
  };

  const handleUserClick = () => {
    setUserDropDown(!userDropDown);
  };

  const handleOrgClick = () => {
    setOrgPopUp(true);
  };

  const handleOrgClose = () => {
    setOrgPopUp(false);
  };

  const handleClickOutside = (event) => {
    if (ref.current && !ref.current.contains(event.target)) {
      setSearchDropDown(false);
      setUserDropDown(false);
      setOrgPopUp(false);
      setIsNotificationPopupOpen(false);
    }
  };

  const handleClose = () => {
    setUserDropDown(false);
  };

  const handleLogout = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_FORE_APILINK}/user/user-logout`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-token': sessionStorage.getItem('token')
        }
      });
  
      const data = await response.json();
  
      if (response.ok) {
        localStorage.removeItem('LoginData');
        sessionStorage.clear();

         // Clear service worker user data
         clearUserFromServiceWorker();

        navigate('/mfr');
      } else {
        console.error('Logout failed:', data.message);
      }
    } catch (error) {
      console.error('Error during logout:', error);
    }
  };

  const handleLogoClick = () => {
    navigate('/mfr/app/mdc');
  };

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

/*   const handleNotificationClick = () => {
    setIsNotificationPopupOpen(!isNotificationPopupOpen);
    if (isNotificationPopupOpen) {
      setNotificationCount(0);  // Reset count when popup is opened
    }
  }; */


  const handleNotificationClick = () => {
  const isOpening = !isNotificationPopupOpen;
  setIsNotificationPopupOpen(isOpening);
  
  if (isOpening) {
    setNotificationCount(0); // Reset count only when opening
  }
};

  
  return (
  <div className="bg-[#21263c] text-[0.8125rem] font-normal w-full h-full flex items-center justify-between overflow-hidden py-2 px-2">

    {/* -------- Desktop Navbar -------- */}
    <div className="hidden md:flex w-full items-center justify-between">
      {/* Left side (Logo + Text) */}
      <div className="flex flex-row space-x-4">
        <div className="flex flex-row items-center px-3">
          <img
            className="w-8 h-8 cursor-pointer"
            src="/BB.png"
            alt="Brick Bucket Logo"
            onClick={handleLogoClick}
          />
          <p className="text-xl text-white ml-2">Brickbucket</p>
        </div>
      </div>

      {/* Right side (Welcome, org, notifications, user) */}
      <div className="flex items-center">
        <div className="flex items-center flex-row text-white space-x-6 mx-2">
          <p className="text-[1rem]">Welcome  Sai</p>
        </div>
        <button
          className="text-white px-4 py-2 mx-2 text-[1rem] hover:bg-[#f7525a] hover:text-white"
          onClick={handleOrgClick}
        >
         Brickbucket Vijayawada {sessionStorage.getItem("organizationName")}
        </button>
        <div className="flex items-center flex-row space-x-6 mx-2">
          <div
            className="relative mx-2 cursor-pointer"
            onClick={handleNotificationClick}
          >
            <FaRegBell className="text-white w-5 h-5" />
            {notificationCount > 0 && (
              <span className="absolute -top-1 -right-1 bg-red-500 text-white rounded-full text-xs w-4 h-4 flex items-center justify-center">
                {notificationCount}
              </span>
            )}
          </div>

          <FontAwesomeIcon
            icon={faUserCircle}
            className="cursor-pointer text-4xl text-white mx-2"
            onClick={handleUserClick}
          />
        </div>
      </div>
    </div>

    {/* -------- Mobile Navbar -------- */}
    <div className="flex md:hidden w-full items-center justify-between">
      {/* Left side (Logo + Text) */}
      <div className="flex flex-row items-center ml-2">
        <img
          className="w-8 h-8 cursor-pointer"
          src="/BB.png"
          alt="Brick Bucket Logo"
          onClick={handleLogoClick}
        />
        <p className="text-xl text-white ml-2">Brickbucket</p>
      </div>

      {/* Right side (Bars) */}
  <div className="flex items-center space-x-3 mr-2">
        <FontAwesomeIcon
      icon={faUserCircle}
      className="cursor-pointer text-3xl text-white"
      onClick={handleUserClick}
    />
    <button onClick={toggleSidebar}>
      <FontAwesomeIcon icon={faBars} className="text-white text-2xl" />
    </button>


  </div>
    </div>

    {/* -------- Popups (same for both views) -------- */}
    {userDropDown && (
      <div
        ref={ref}
        className="absolute right-0 z-[999] top-12 bg-white shadow-md border-[#6c7184] rounded-[0.5rem] w-96"
      >
        <div className="p-4 bg-[#fbfbfb]">
          <div className="flex flex-col p-2">
            <div className="flex flex-row justify-between pb-2">
              <div className="flex flex-row">
                <div>
                  <img
                    className="rounded-md w-8 h-8 cursor-pointer"
                    src="/usericon.gif"
                    alt="User Icon"
                  />
                </div>
                <div className="mt-2 ml-2">
                  <p>{sessionStorage.getItem("username")}</p>
                  <p className="font-semibold">
                   {sessionStorage.getItem("roleName")}
                  </p>
                  <p>{sessionStorage.getItem("organizationName")}</p>
                </div>
              </div>
              <div>
                <button onClick={handleClose}>
                  <FontAwesomeIcon
                    icon={faX}
                    className="cursor-pointer text-md text-[#f7525a] mx-2"
                  />
                </button>
              </div>
            </div>
            <div className="p-2 border-t border-b flex justify-end">
              <button onClick={handleLogout} className="text-[#f7525a] text-md">
                <FontAwesomeIcon
                  icon={faSignOut}
                  className="cursor-pointer text-md text-[#f7525a] mx-2"
                />
                Sign Out
              </button>
            </div>
          </div>
        </div>
      </div>
    )}

    {orgPopUp && (
      <div
        ref={ref}
        className="absolute right-0 z-10 top-12 bg-white shadow-md border-[#6c7184] rounded-[0.5rem] w-96"
      >
        <div className="p-4 bg-[#fbfbfb]">
          <div className="flex flex-col p-2">
            <div className="flex flex-row justify-between pb-2">
              <div className="flex flex-row">
                <FontAwesomeIcon
                  icon={faBuilding}
                  className="cursor-pointer w-8 h-8 text-md text-[#f7525a] mt-3 mx-2"
                />
                <div className="mt-2 ml-2">
                  <p>{sessionStorage.getItem("organizationName")}</p>
                  <p>{sessionStorage.getItem("organizationNumber")}</p>
                </div>
              </div>
              <div>
                <button onClick={handleOrgClose}>
                  <FontAwesomeIcon
                    icon={faX}
                    className="cursor-pointer text-md text-[#f7525a] mx-2"
                  />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    )}

    {isNotificationPopupOpen && (
      <div
        ref={ref}
        className="absolute right-0 z-50 top-16 bg-white shadow-md border-[#6c7184] rounded-[0.5rem] w-96"
      >
        <div className="p-4 bg-[#fbfbfb]">
          <div className="flex flex-col p-2">
            <div className="flex flex-row justify-between pb-2">
              <p className="font-semibold">Notifications</p>
              <button onClick={() => setIsNotificationPopupOpen(false)}>
                <FontAwesomeIcon
                  icon={faX}
                  className="cursor-pointer text-md text-[#f7525a] mx-2"
                />
              </button>
            </div>
            <div className="p-2">
              {notifications.length > 0 ? (
                notifications.map((notification, index) => (
                  <div key={index} className="py-2 border-b border-gray-200">
                    <p className="font-semibold">{notification.title}</p>
                    <p>{notification.body}</p>
                    <p className="text-xs text-gray-500">{notification.time}</p>
                  </div>
                ))
              ) : (
                <p>No notifications</p>
              )}
            </div>
          </div>
        </div>
      </div>
    )}
  </div>
);

};

export default MHeader;
